class EmmaliciousCocadaMix extends HTMLElement {
  connectedCallback() {
    if (this._controller) return;
    this._controller = new AbortController();
    this.addEventListener('change', () => this.sync(), {signal: this._controller.signal});
    this.sync();
  }
  disconnectedCallback() {
    this._controller?.abort();
    this._controller = null;
  }
  get enabled() { return Boolean(this.querySelector('[data-emma-mix-toggle]')?.checked); }
  get selection() {
    const fields = [...this.querySelectorAll('[data-emma-piece]')];
    const valid = fields.length === 4 && fields.every(field => field.value && [...field.options].some(option => option.value === field.value));
    return {valid, value: valid ? 'Mix & match: ' + fields.map((field, i) => (i + 1) + ') ' + field.value).join(', ') + '; Small syrup pouches: 4 total, 1 matching each cocada' : '', labels: fields.map(field => field.selectedOptions[0]?.textContent || '')};
  }
  sync() {
    const active = this.enabled;
    const cup = this.closest('.bundle-cups__cup, .emma-cocada-flavor');
    if (!cup) return;
    const standard = cup.querySelector('[data-emma-standard-flavor], .bundle-cups__choices--cocada');
    if (standard) {
      standard.hidden = active;
      standard.querySelectorAll('input').forEach(input => { input.disabled = active; });
    }
    const extra = cup.querySelector('.emma-syrup-choice');
    if (extra) {
      extra.hidden = active;
      extra.querySelectorAll('input').forEach(input => { input.disabled = active; if (active) input.checked = false; });
    }
    this.querySelector('[data-emma-mix-fields]').hidden = !active;
    this.querySelectorAll('[data-emma-piece]').forEach(field => { field.disabled = !active; field.required = active; });
    const output = this.querySelector('[data-emma-mix-property]');
    if (output) { output.disabled = !active; output.value = active ? this.selection.value : ''; }
    const status = this.querySelector('[data-emma-mix-summary]');
    status.textContent = active && this.selection.valid ? this.selection.labels.map((label,i) => (i+1) + '. ' + label).join(' · ') : '';
  }
  validate() {
    if (!this.enabled || this.selection.valid) return true;
    const panel = this.closest('details');
    if (panel) panel.open = true;
    const field = [...this.querySelectorAll('[data-emma-piece]')].find(input => !input.value);
    field?.focus();
    field?.reportValidity();
    return false;
  }
}
if (!customElements.get('emmalicious-cocada-mix')) customElements.define('emmalicious-cocada-mix', EmmaliciousCocadaMix);
